import { Button } from '@fl/cmsch-fe-library';
import { isEmpty } from 'lodash/fp';
import React, { FC, useCallback } from 'react';
import { OrganizationRoleManagement } from 'api/gen/OrganizationRoleManagement';
import { useOurTranslation } from 'app/translations';
interface Props {
  /** Source organization-role row. */
  role: OrganizationRoleManagement;
  /** Builds the tooltip text for farms and centers. */
  computeFarmsAndCentersTooltip(farmIds: Array<number> | null, centerIds: Array<number> | null, hasAccessToAllOrganizationCenters: boolean, hasAccessToAllFarms: boolean): string;
  /** Callback invoked when the action is clicked. */
  onCellClick(role: OrganizationRoleManagement): void;
}

/**
 * Renders a clickable organization-management table action.
 *
 * @param props Organization row, tooltip builder, and click callback.
 * @returns Clickable organization-management table action.
 */
export const DynamicContent: FC<Props> = ({
  role,
  computeFarmsAndCentersTooltip,
  onCellClick
}) => {
  const {
    hasAccessToAllFarms,
    farmIds,
    hasAccessToAllOrganizationCenters,
    organizationCenterIds
  } = role;
  const {
    t
  } = useOurTranslation('admin');
  const handleCellClick = useCallback((): void => {
    onCellClick(role);
  }, [onCellClick, role]);
  if (hasAccessToAllFarms && hasAccessToAllOrganizationCenters) {
    return <Button icon="greenCheckCircleFilled" visuals="text" block tooltip={t('allFarmsAndOrganizations')} onClick={handleCellClick} />;
  }

  // has no farms nor centers access
  if (!hasAccessToAllFarms && !hasAccessToAllOrganizationCenters && isEmpty(farmIds) && isEmpty(organizationCenterIds)) return <span />;
  return <Button icon="threeDotsCircle" visuals="text" tooltip={computeFarmsAndCentersTooltip(farmIds, organizationCenterIds, hasAccessToAllOrganizationCenters, hasAccessToAllFarms)} block onClick={handleCellClick} data-sentry-element="Button" data-sentry-component="DynamicContent" data-sentry-source-file="gen-dynamic-content.tsx" />;
};